(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.PerfMarks = {}));
}(this, (function (exports) { 'use strict';

    /**
     * Boolean with the result of the check if User Timing API
     * is supported for the current browser/NodeJS version
     *
     * @returns boolean
     *
     */
    var isUserTimingAPISupported = typeof performance !== 'undefined' &&
        typeof performance.now !== 'undefined' &&
        typeof performance.mark === 'function' &&
        typeof performance.clearMarks === 'function' &&
        typeof performance.measure === 'function' &&
        typeof performance.clearMeasures === 'function';

    /**
     * Boolean with the result of the check if PerformanceObservable
     * is supported for the current browser/NodeJS version
     *
     * @returns boolean
     *
     */
    var isPerformanceObservableSupported = typeof PerformanceObserver !== 'undefined' &&
        typeof PerformanceObserver.prototype !== 'undefined' &&
        typeof PerformanceObserver.prototype.constructor === 'function';

    // Map() is not used in order to decrease the bundle
    var marksMap = {};
    /**
     * Get the current time based on User Timing API or Date
     *
     * @returns number
     *
     */
    var getTimeNow = function () {
        if (isUserTimingAPISupported) {
            return performance.now();
        }
        return Date.now();
    };
    /**
     * Clear marks and measure of performance event
     *
     * @param markName - Performance marker to be checked
     *
     * @returns void
     *
     */
    var clear = function (markName) {
        marksMap[markName] = undefined;
        if (!isUserTimingAPISupported) {
            return;
        }
        performance.clearMeasures(markName);
        performance.clearMarks(markName);
    };
    /**
     * Start performance measure of event
     *
     * @param markName - Performance marker to be started
     *
     * @returns number
     *
     */
    var start = function (markName) {
        if (isUserTimingAPISupported) {
            performance.mark(markName);
        }
        marksMap[markName] = getTimeNow();
    };
    /**
     * Finishes performance measure of event and
     * clear marks and measure if applicable
     *
     * @param markName - Performance marker to be checked
     * @param markNameToCompare - Optional mark to compare to
     *
     * @returns PerfMarksPerformanceEntry
     *
     */
    var end = function (markName, markNameToCompare) {
        try {
            var startTime = marksMap[markName];
            if (!isUserTimingAPISupported) {
                return startTime ? { duration: getTimeNow() - startTime, startTime: startTime } : {};
            }
            performance.measure(markName, markName, markNameToCompare || undefined);
            var entry = performance.getEntriesByName(markName).pop();
            return entry || {};
        }
        catch (e) {
            // If previous mark was missing for some reason, this will throw.
            // This could only happen if something in event loop crashed
            // in an unexpected place earlier.
            // Don't pile on with more errors.
            return {};
        }
        finally {
            // Clear marks immediately to avoid growing buffer.
            clear(markName);
        }
    };
    /**
     * Clear all marks and measures of performance event
     *
     * @returns void
     *
     */
    var clearAll = function () {
        marksMap = {};
        if (!isUserTimingAPISupported) {
            return;
        }
        performance.clearMeasures();
        performance.clearMarks();
    };

    /**
     * Gets the result for all marks that matches with the given mark name
     *
     * @param markName - Performance marker to be checked
     *
     * @returns PerfMarksPerformanceNavigationTiming[]
     *
     */
    var getEntriesByType = function (entryName) {
        if (!isUserTimingAPISupported) {
            return [];
        }
        return performance.getEntriesByType(entryName) || [];
    };
    /**
     * Gets the marks for `navigation` loaded mark
     *
     * @returns PerfMarksPerformanceNavigationTiming[]
     *
     */
    var getNavigationMarker = function () { return getEntriesByType('navigation').pop() || {}; };

    exports.clear = clear;
    exports.clearAll = clearAll;
    exports.end = end;
    exports.getEntriesByType = getEntriesByType;
    exports.getNavigationMarker = getNavigationMarker;
    exports.isPerformanceObservableSupported = isPerformanceObservableSupported;
    exports.isUserTimingAPISupported = isUserTimingAPISupported;
    exports.start = start;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
